module.exports = {"data":{"markdownRemark":{"html":"<p>This website was built with Gatsby.js. Thanks for your visit!</p>","frontmatter":{"title":"Welcome to My Portolio Website","date":"10 January, 2018"}}},"pathContext":{"slug":"/welcome/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/welcome.json
// module id = 410
// module chunks = 276933693913514